import { createApp } from 'vue'
import FHashtag from '~/js/components/hashtag'

const ID = 'js-pagesHashtag'

document.addEventListener('DOMContentLoaded', async () => {
  const element = document.getElementById(ID)
  if (!element) return

  createApp({
    name: 'PagesHashtag',
    components: {
      FHashtag,
    },
  }).mount(element)
})
